export default function initLazyLoad() {
	jQuery('.bg-stretch:has(iframe)').each(function(i, holder) {
		var $iframe = jQuery(this).find('iframe');

		var observer = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					checkAndLoadIframe();

					observer.unobserve(entry.target);
				}
			});
		});

		observer.observe(holder);

    function checkAndLoadIframe() {
      const cookiesRequired = !!$iframe.data('cookiesRequired');
      const cookiesAccepted = !!(window.ccc && window.ccc.functional);
      const canLoadVideo = !cookiesRequired || (cookiesRequired && cookiesAccepted);
      if (canLoadVideo) {
        loadIframe();
      } else {
        setTimeout(checkAndLoadIframe, 500);
      }
    }

    function handleIframeLoaded() {
      $iframe.addClass('loaded');
      setTimeout(function() { jQuery('.intro-section-video--poster').css('opacity', 0); }, 5000);
    }

		function loadIframe() {
			$iframe.on('load', function() {
        handleIframeLoaded();
			});

      var newSource = $iframe.data('src');
      var existingSoruce = $iframe.attr('src');
      if (newSource && newSource !== existingSoruce) {
        $iframe.attr('src', newSource);
      } else {
        handleIframeLoaded();
      }
      const userAgent = navigator.userAgent.toLowerCase();
      const isTablet = /(ipad|macintosh|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
      let portraitSource = $iframe.data('src-portrait');
      let isPortrait = (window.screen.orientation && ["portrait-secondary", "portrait-primary"].includes(window.screen.orientation.type)) || window.matchMedia("(orientation: portrait)").matches;

      if (!isTablet && isPortrait && portraitSource) {
        $iframe.attr('src', portraitSource);
      }
    }
	});
}
